import { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";
import { InputRHFV2 } from "../../Atoms/InputsRHF/InputRHFV2";
import { MessageErroFormV2 } from "../../Atoms/MessageErroFormV2";
import { ButtonV2 } from "../../Atoms/ButtonV2";
import {
  IFormBuscarVeiculoPorChassiValues,
  IFormBuscarVeiculoPorPlacaValues,
  useFormBuscarVeiculoPorChassi,
  useFormBuscarVeiculoPorPlaca,
} from "./useFormBuscarVeiculoV2";

interface IFormBuscarVeiculoV2BaseProps extends ComponentProps<"form"> {}

interface IFormBuscarVeiculoPorPlacaProps
  extends IFormBuscarVeiculoV2BaseProps {
  modo: "placa";
  onSubmitForm: (data: IFormBuscarVeiculoPorPlacaValues) => void;
}

interface IFormBuscarVeiculoPorChassiProps
  extends IFormBuscarVeiculoV2BaseProps {
  modo: "chassi";
  onSubmitForm: (data: IFormBuscarVeiculoPorChassiValues) => void;
}

type IFormBuscarVeiculoV2Props =
  | IFormBuscarVeiculoPorPlacaProps
  | IFormBuscarVeiculoPorChassiProps;

const ConsultarButton = () => (
  <ButtonV2 type="submit" className="shrink-0">
    <img src="/assets/svgs/icon-zoom-in.svg" alt="" className="h-3.5 w-3.5" />
    Consultar
  </ButtonV2>
);

const FormBuscarVeiculoPorPlaca = ({
  onSubmitForm,
  className,
  ...rest
}: Omit<IFormBuscarVeiculoPorPlacaProps, "modo">) => {
  const { register, handleSubmit, errors } = useFormBuscarVeiculoPorPlaca();

  return (
    <form
      {...rest}
      onSubmit={handleSubmit(onSubmitForm)}
      className={twMerge(
        "flex w-full flex-col items-start gap-8 rounded-[10px] border border-solid border-[#e5e5ea] bg-white p-8 shadow-[0_8px_24px_0_rgba(0,0,0,0.078)] sm:flex-row sm:items-center",
        className,
      )}
    >
      <div className="flex w-full flex-col gap-8 sm:flex-row">
        <div className="w-full">
          <InputRHFV2
            id="placa"
            label="Placa*"
            {...register("placa")}
          />
          {errors?.placa && (
            <MessageErroFormV2>{errors.placa.message}</MessageErroFormV2>
          )}
        </div>
        <div className="w-full">
          <InputRHFV2
            id="renavam"
            label="Renavam*"
            inputMode="numeric"
            {...register("renavam")}
          />
          {errors?.renavam && (
            <MessageErroFormV2>{errors.renavam.message}</MessageErroFormV2>
          )}
        </div>
      </div>

      <ConsultarButton />
    </form>
  );
};

const FormBuscarVeiculoPorChassi = ({
  onSubmitForm,
  className,
  ...rest
}: Omit<IFormBuscarVeiculoPorChassiProps, "modo">) => {
  const { register, handleSubmit, errors } = useFormBuscarVeiculoPorChassi();

  return (
    <form
      {...rest}
      onSubmit={handleSubmit(onSubmitForm)}
      className={twMerge(
        "flex w-full flex-col items-start gap-8 rounded-[10px] border border-solid border-[#e5e5ea] bg-white p-8 shadow-[0_8px_24px_0_rgba(0,0,0,0.078)] sm:flex-row sm:items-center",
        className,
      )}
    >
      <div className="w-full">
        <InputRHFV2 id="chassi" label="Chassi*" {...register("chassi")} />
        {errors?.chassi && (
          <MessageErroFormV2>{errors.chassi.message}</MessageErroFormV2>
        )}
      </div>

      <ConsultarButton />
    </form>
  );
};

export const FormBuscarVeiculoV2 = ({
  modo,
  onSubmitForm,
  ...rest
}: IFormBuscarVeiculoV2Props) => {
  if (modo === "placa") {
    return (
      <FormBuscarVeiculoPorPlaca onSubmitForm={onSubmitForm} {...rest} />
    );
  }

  return <FormBuscarVeiculoPorChassi onSubmitForm={onSubmitForm} {...rest} />;
};
